export var getCookie = function (name) {
    var visitaId = document.getElementById("visita_id");
    if (visitaId && visitaId.value !== "") {
        return visitaId.value;
    }
    return null;
};
